import React from "react";
import styles from "./stats.module.css";
import { FaBitcoin } from "react-icons/fa";

const Stats = ({ statsData, type }) => {
  return (
    <div className={styles.container}>
      {statsData?.map((stat, index) => (
        <div
          key={index}
          className={styles.card}
        >
          <div className={styles.content}>
            <p className={styles.title}>{type === "investment" ? stat.title1 : stat.title}</p>
            <h6 className={styles.value}>{type === "investment" ? stat.value1 : stat.value}</h6>
          </div>
          {type === "investment" ?
            (<div className={styles.content}>
              <p className={styles.title}>{stat.title2}</p>
              <h6 className={styles.value}>{stat.value2}</h6>
            </div>) :
            (<div className={styles.iconBox}>
              <FaBitcoin size={30} />
            </div>)}
          <div className={styles.gradientBar} />
        </div>
      ))}
    </div>
  );
};

export default Stats;
